export default "__VITE_PUBLIC_ASSET__9808e809__"